

import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { API } from 'aws-amplify'
import StoryTitle from '../components/StoryTitle'
import StoryTable from '../components/StoryTable'
import color from '../shared/color'
import {DonutChart, StackBarChart,ThresholdBarChart } from '../d3'
import { Typography, Grid, CircularProgress, Paper } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import '../story.css'

function DriveSpaceMonitoring() {
    const [isLoading, setIsLoading] = useState(true)
    const [title, setTitle] = useState("Drive Space Monitoring")
    const [summary, setSummary] =  useState("Using Windows Events for Device Size to show growth for an overview to monitor and prevent critical issues")
    const [categories] = useState(["risk","database"])
    const [data, setData] = useState(null)
	const [facilityLayout] = useState([
		{column:"Customer Name", field:"customername"},
        {column:"Facility", field:"facilityname"},
        {column:"Drive Status",field:"HDD_Status"},
        {column:"Unique Devices",field:"nunique"}])
    const [trafficLight] = useState(["#b60a1c","#e39802", "#179f47","#ffda66"]
    )
    const useStyles = makeStyles({
        table: {
            minWidth: 650,
        },
    })


    let history = useHistory()

    function sortObject(obj) {
    return Object.keys(obj).sort().reduce(function (result, key) {
        result[key] = obj[key];
        return result;
    }, {});
}

    useEffect(() => {
        async function fetch() {
            await API.get('qs-web-api', '/data/hdd_monitoring/data.json', {})
                .then((storyData) => {
                    setData(storyData)
                })
                .catch(function (error) {
                    console.log(error)
                })
            setIsLoading(false)
        }
        fetch()
    }, [])

    if (isLoading) {
        return (<div className="circular-progress"><CircularProgress disableShrink /></div>)
    } else {
        return (
            <div id="story">
                <StoryTitle title={title} date={data.date} categories={categories}></StoryTitle>
                <Paper className="storySection">
                <Grid container justify="center" spacing={2} alignItems="stretch">
                    <div className="subText">
                        <Typography>
                            Monitoring the state of the SQL, C , D and other drives ensures that the medical devices work properly. Issue occur when areas of the device bloat from patches or deployed packages that do not clean up well. Ensuring properly telemetry and proactive measure will keep the customer happy. Devices are monitored with the windows events 4529 and 4530 production data.
                            <p>Insufficient DB and Drive space will cause data retention failures disabling the customer ability to utilize BD Medical devices.</p>
                        </Typography>
                    </div>
                </Grid>
                </Paper>



                <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                                Drive count for the status in the field.
                            </Typography>
                        </div>
                    </Grid>
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <DonutChart id={1} data={sortObject(data.donutAll)} colors={trafficLight} tooltip={"Number of Devices: "}
                            width={800} height={400} radius={200}></DonutChart>
                    </Grid>

                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="subText">
                            <Typography>
                                Overview of all devices drives and their status in the field grouped by if they are
                                <ul>
                                  <li>Critical - Less then 5%</li>
                                  <li>Very Low - Less then 10%</li>
                                  <li>Low - Less then 15%</li>
                                    <li>Normal - Greater then 15%</li>
                                </ul>
                            </Typography>
                        </div>
                    </Grid>

                    <Grid container justify="center" spacing={2} alignItems="stretch" >
                        <ThresholdBarChart
                            data={data.barchartTracking}
                            axis = {{y:"total"}}
                            colors={color.defaultScheme}
                            tooltip={""}
                            width={800}
                            height={400}>
                        </ThresholdBarChart >
                    </Grid>
                </Paper>


                <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                                Monitoring of Drive At Risk Status
                            </Typography>
                        </div>
                    </Grid>
                <Grid container justify="center" spacing={2} alignItems="stretch" >
<StackBarChart
                            data={data.trackingStacked}
                            axis = {{y:"total"}}
                            colors={["#b60a1c","#ffda66","#e39802"]}
                            tooltip={""}
                            width={800}
                            height={400}>
                        </StackBarChart>
                </Grid>
                    <div className="subText">
                    <Typography>
                                High Level monitoring of how many drives in the field are critical, very low or low. Ensuring that the drives do not reach low will give more time to react to issues.
                            </Typography>
                    </div>
                </Paper>

                <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                                C Drive count for the status in the field with Critical Issues
                            </Typography>
                        </div>
                    </Grid>
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <DonutChart id={1} data={sortObject(data.cDonut)} colors={trafficLight} tooltip={"Number of Devices: "}
                            width={800} height={400} radius={200}></DonutChart>
                    </Grid>
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                    <div className="subText">
                    <Typography>
                        Monitoring of the space status for all C drives in the field.
                    </Typography>
                    </div>
                    </Grid>

                </Paper>
                <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                                C Drive Critical Monitoring by Highest Facilities
                            </Typography>
                        </div>
                    </Grid>
                    <StoryTable data={data.cCriticalList} layout={facilityLayout}></StoryTable>

                    <Grid container justify="center" spacing={2} alignItems="stretch">
                    <div className="subText">
                    <Typography>
                        Facilities with the worst rate of C Drive critical space issues.
                    </Typography>
                    </div>
                    </Grid>

                </Paper>
                <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                                C Drive Critical and Very Low Monitoring by Highest Facilities
                            </Typography>
                        </div>
                    </Grid>
                    <StoryTable data={data.cVeryList} layout={facilityLayout}></StoryTable>

                    <Grid container justify="center" spacing={2} alignItems="stretch">
                    <div className="subText">
                    <Typography>
                        Facilities with the worst rate of C Drive critical and near critical space issues.
                    </Typography>
                    </div>
                    </Grid>

                </Paper>


                <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                                SQL count for the status in the field with Critical Issues
                            </Typography>
                        </div>
                    </Grid>
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <DonutChart id={1} data={sortObject(data.sqlDonut)} colors={trafficLight} tooltip={"Number of Devices: "}
                            width={800} height={400} radius={200}></DonutChart>
                    </Grid>


                    <Grid container justify="center" spacing={2} alignItems="stretch">
                    <div className="subText">
                    <Typography>
                        Monitoring of the space status for all SQL space in the field.
                     </Typography>
                    </div>
                    </Grid>

                </Paper>
                <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                                SQL Space Critical Monitoring by Highest Facilities
                            </Typography>
                        </div>
                    </Grid>
                    <StoryTable data={data.sqlCriticalList} layout={facilityLayout}></StoryTable>


                    <Grid container justify="center" spacing={2} alignItems="stretch">
                    <div className="subText">
                    <Typography>
                        Facilities with the worst rate of SQL critical space issues.
                    </Typography>
                    </div>
                    </Grid>

                </Paper>
                <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                                SQL Space Critical and Very Low Monitoring by Highest Facilities
                            </Typography>
                        </div>
                    </Grid>
                    <StoryTable data={data.sqlVeryList} layout={facilityLayout}></StoryTable>

                    <Grid container justify="center" spacing={2} alignItems="stretch">
                    <div className="subText">
                    <Typography>
                        Facilities with the worst rate of SQL critical and near critical space issues.
                    </Typography>
                    </div>
                    </Grid>

                </Paper>

                <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                                D Drive count for the status in the field with Critical Issues
                            </Typography>
                        </div>
                    </Grid>
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <DonutChart id={1} data={sortObject(data.dDonut)} colors={trafficLight} tooltip={"Number of Devices: "}
                            width={800} height={400} radius={200}></DonutChart>
                    </Grid>

                    <Grid container justify="center" spacing={2} alignItems="stretch">
                    <div className="subText">
                    <Typography>
                        Monitoring of the space status for all D drive space in the field.
                    </Typography>
                    </div>
                    </Grid>
                </Paper>
                <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                                D Drive Critical Monitoring by Highest Facilities
                            </Typography>
                        </div>
                    </Grid>
                    <StoryTable data={data.dCriticalList} layout={facilityLayout}></StoryTable>

                    <Grid container justify="center" spacing={2} alignItems="stretch">
                    <div className="subText">
                    <Typography>
                        Facilities with the worst rate of D drive critical space issues.
                    </Typography>
                    </div>
                    </Grid>

                </Paper>
                <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                                D Drive Critical and Very Low Monitoring by Highest Facilities
                            </Typography>
                        </div>
                    </Grid>
                    <StoryTable data={data.dVeryList} layout={facilityLayout}></StoryTable>

                    <Grid container justify="center" spacing={2} alignItems="stretch">
                    <div className="subText">
                    <Typography>
                        Facilities with the worst rate of D drive critical and near critical space issues.
                    </Typography>
                    </div>
                    </Grid>
                </Paper>


                <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                                Other Drive count for the status in the field with Critical Issues
                            </Typography>
                        </div>
                    </Grid>
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <DonutChart id={1} data={sortObject(data.otherDonut)} colors={trafficLight} tooltip={"Number of Devices: "}
                            width={800} height={400} radius={200}></DonutChart>
                    </Grid>

                    <Grid container justify="center" spacing={2} alignItems="stretch">
                    <div className="subText">
                    <Typography>
                        Monitoring of the space status for all Drives like E,F,G... space in the field.
                    </Typography>
                    </div>
                    </Grid>

                </Paper>
                <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                                Other Drive Critical Monitoring by Highest Facilities
                            </Typography>
                        </div>
                    </Grid>
                    <StoryTable data={data.otherCriticalList} layout={facilityLayout}></StoryTable>

                    <Grid container justify="center" spacing={2} alignItems="stretch">
                    <div className="subText">
                    <Typography>
                        Facilities with the worst rate of other drive critical  space issues.
                    </Typography>
                    </div>
                    </Grid>

                </Paper>
                <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                                Other Drive Critical and Very Low Monitoring by Highest Facilities
                            </Typography>
                        </div>
                    </Grid>
                    <StoryTable data={data.otherVeryList} layout={facilityLayout}></StoryTable>

                    <Grid container justify="center" spacing={2} alignItems="stretch">
                    <div className="subText">
                    <Typography>
                        Facilities with the worst rate of other drive critical and near critical  space issues.
                    </Typography>
                    </div>
                    </Grid>

                </Paper>



            </div >
        )
    }
}
export default DriveSpaceMonitoring

